module.exports = __webpack_public_path__ + "static/media/abstract landmark 2.d8d3130b.pxm";